import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit, Renderer2, ViewChild } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { GeneralService } from "src/app/Service/general.service";
import { AddCallAlertFormComponent } from "../add-call-alert-form/add-call-alert-form.component";
import { MatDialog } from "@angular/material";

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-call-alert-list",
  templateUrl: "./call-alert-list.component.html",
  styleUrls: ["./call-alert-list.component.scss"],
})
export class CallAlertListComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  usersData: any;
  userId: any;
  callAlertTypes: any[] = [];
  dtOptions: DataTables.Settings = {};
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject<any>();
  isLoading: boolean = false;
  param: any;
  public daterange: any = {};
  dates: { endDate: string; startDate: string };
  currentUser: any;
  date: any = new Date();
  @Input() Type: string;
  myGroup: FormGroup;
  dateRangeValue: string;
  isshow: boolean = false;

  constructor(
    private service: GeneralService,
    private http: HttpClient,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private rerender2: Renderer2
  ) {}

  ngOnInit() {
    this.currentUser = this.service.getcurrentUser();
    this.myGroup = new FormGroup({
      date: new FormControl(null),
    });
    this.OnDateChange();
    this.breadCrumbItems = [
      { label: "Dashboard", path: "/users" },
      {
        label: "Follow Up Report",
        path: "/users/users-callAlertList/",
        active: true,
      },
    ];

    this.dtOptions = {
      pagingType: "simple_numbers",
      pageLength: 10,
      processing: true,
      serverSide: true,
      ordering: false,
      searching: false,
      ajax: (dataTablesParameters: any, callback) => {
        this.isLoading = true;
        this.http
          .get<DataTablesResponse>(
            `${this.service.callAlertList()}/${
              dataTablesParameters.search.value != ""
                ? dataTablesParameters.search.value + "/"
                : ""
            }${
              (dataTablesParameters.start + dataTablesParameters.length) /
              dataTablesParameters.length
            }/${dataTablesParameters.length}${
              this.dates
                ? "?startdate=" +
                  this.dates.startDate +
                  "&enddate=" +
                  this.dates.endDate
                : ""
            }${
              this.currentUser.franchise_Id
                ? `?franchise_id=${this.currentUser.franchise_Id}`
                : ""
            }`,
            {}
          )
          .subscribe((resp: any) => {
            if (resp.total_count) {
              callback({
                recordsTotal: resp.total_count,
                recordsFiltered: `${
                  resp.data[0].filtercount
                    ? resp.data[0].filtercount
                    : resp.total_count
                }`,
                data: resp.data,
              });
              this.isLoading = false;
            } else {
              callback({
                recordsTotal: resp.total_count,
                recordsFiltered: resp.total_count,
                data: resp.data,
              });
              this.isLoading = false;
            }
          });
      },
      responsive: true,
      columns: [
        {
          title: "User ID",
          data: null,
          render: (data) => {
            return data.user_id;
          },
        },
        {
          title: "User Name",
          data: null,
          render: (data) => {
            return data.UserName;
          },
        },
        {
          title: "User Type",
          data: null,
          render: (data) => {
            return data.Status ? data.Status : "--";
          },
        },
        {
          title: "Alert Type",
          data: null,
          render: (data) => {
            return data.alert_type;
          },
        },
        {
          title: "Follow up Date and Time",
          data: null,
          render: (data) => {
            return this.datePipe.transform(
              data.follow_up_date,
              "dd/MM/yyyy HH:mm:ss",
              "UTC"
            );
          },
        },
        {
          title: "Called By",
          data: null,
          render: (data) => {
            return data.csrName;
          },
        },
        {
          title: "Priority",
          data: null,
          render: (data) => {
            return data.PriorityType;
          },
        },

        {
          title: "Action",
          data: null,
          render(data) {
            return `<div style="display:flex">
            
            <a class="ml-1 text-primary plus" title="Add Call Alert"  >
            <i class="ml-1 font-18 mdi mdi-plus text-secondary" userid="${data.user_id}" ></i></a>
          </div>
            `;
          },
        },
      ],
      // Function to format remarks
      drawCallback: () => {
        // this.formatChildRow()
        $(".plus").on("click", (e) => {
          this.userId = e.target.getAttribute("userid");
          this.openDialog();
        });
      },
    };
  }
  // formatRemarks = (data) => {
  //   return `<div class="remarks-content ml-4">${data.call_remarks}</div>`;
  // }
  selectedDate(value: any) {
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    let startDate = new Date(this.daterange.start);
    let endDate = new Date(this.daterange.end);
    const formattedStartDate = `${startDate.getFullYear()}-${(
      startDate.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${startDate.getDate().toString().padStart(2, "0")}`;
    const formattedEndDate = `${endDate.getFullYear()}-${(
      endDate.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${endDate.getDate().toString().padStart(2, "0")}`;
    // this.getCalenderType(this.daterange);
    let dates = { endDate: formattedEndDate, startDate: formattedStartDate };
    this.dates = dates;
    console.log("date", this.dates);
    this.dateRangeValue = formattedStartDate + " To " + formattedEndDate;
    this.isshow = true;
    this.rerender();
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
  datechange() {
    let dateRange = document.getElementById("daterangeInput");
    if (dateRange) {
      dateRange.click();
    }
  }
  resetForm() {
    this.myGroup.reset();
    this.dates = undefined;
    this.dateRangeValue = null;
    this.isshow = false;
    // this.myGroup.controls.date.setValue(null)
    this.rerender();
  }
  // formatChildRow(rowData: any): string {
  //   console.log('rowdat',rowData)
  //   const childRowData = [];
  //   childRowData.push(rowData);
  //   // event.preventDefault();
  //   // console.log("child row data",rowData);
  //   let childRowHtml = '<div style="display:flex">';
  //   childRowHtml += '<span><b>Remarks:</b></span>';

  //   if (childRowData.length > 0) {
  //     childRowData.forEach((row: any, index: number) => {
  //       const rowColor = index % 2 === 0 ? 'white' : '#F1F5F7';
  //       childRowHtml += '<div style="background-color:' + rowColor + '"></div>';
  //       childRowHtml += '<span class="ml-1">' + this.renderData(row.call_remarks) + '</span>';
  //     });
  //   } else {
  //     childRowHtml += '<span colspan="3">No Remarks Available</span>';
  //   }
  //   childRowHtml += '</div>';

  //   // console.log("myAnchor",checkbox)
  //   // checkbox.addEventListener('change')
  //   // console.log("document",childRowData)
  //   // console.log("document",childRowHtml)

  //   return childRowHtml;
  // }
  ngAfterViewInit() {
    this.dtTrigger.next();
  }
  Downlaod() {
    window.open(
      `${this.service.dailyreportExcel()}?startdate=${
        this.dates.startDate
      }&enddate=${this.dates.endDate}&isDailyCall=true`,
      "_blank"
    );
  }
  OnDateChange() {
    if (this.myGroup.controls.date.value) {
      const today = new Date(this.myGroup.controls.date.value);
      this.formateDate(today);
      this.rerender();
    } else {
      const today = new Date();
      this.formateDate(today);
    }
  }

  formateDate(date: any) {
    const yyyy = date.getFullYear();
    let mm = Number(date.getMonth() + 1); // Months start at 0!
    let dd = Number(date.getDate());
    const formattedToday = yyyy + "-" + mm + "-" + dd;
    this.param = formattedToday;
    return this.param;
  }

  refresh() {
    this.myGroup.reset();
    this.OnDateChange();
    this.rerender();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(AddCallAlertFormComponent, {
      width: "600px",
      autoFocus: false,
      maxHeight: "90vh",
      disableClose: true,
    });
    dialogRef.componentInstance.userId = this.userId;
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.rerender();
      }
    });
  }
  close() {
    this.dialog.closeAll();
  }
  renderData(data) {
    if (data === "" || data === null || data === "null") {
      return "--";
    } else {
      return data;
    }
  }
}
